import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import no_image_available from '../images/no_image_available.jpg';

const PopupImage = () => {

    const [newsList, SetNews] = useState([]);

    const settings = {
        dots: true,
        infinite: true,
        speed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        //dotsClass: "button__bar",
        customPaging: i => (
            <button className="slick-dot"></button>
        ),
    };

     const urlImg = `${process.env.REACT_APP_BASEURL}/galeri/`;
    
    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_ENDPOINT}/image_popup`)
            .then((res) => {
                return res.json();
            })
            .then((datas) => {
                //console.log(datas);
                SetNews(datas.data);
            });
    }, []);


    return (
        <div className="max-w-[680px] mx-auto">
            <div className="relative overflow-y-scroll" style={{ msOverflowStyle: 'none', scrollbarWidth: 'none' }}>
                {newsList.map((data_news, indexnews_list) => (
                    <>
                        <div>
                            <a href={data_news.link} target='_blank'>
                            {data_news?.file != '' ?
                                <img src={urlImg + '' + data_news.file} alt="Image" style={{ width: '680px', height: '380px' }} />
                                :
                                <img src={no_image_available} alt="" />
                            }
                            <p className="flex justify-center">
                                {data_news.name}
                            </p>
                            {/*<p className="flex justify-center">
                                    <a href={data_news.link} target='_blank' class="bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow">Detail</a>
                            </p>*/}
                            </a>
                        </div>
                        
                    </>
                ))}    
            </div>
        </div>
    );
};

export default PopupImage;
